/**
 * How to reach the people who make this.
 *
 * One definition, because the address appears in two places that were previously
 * independent: the footer link, whose `mailto:` was written inline while the text
 * beside it came from a dictionary, and the empty-catalogue message, which repeated
 * it inside a sentence in all three languages. Six copies of one address, three of
 * them in prose, is six chances to change five of them.
 *
 * It lives here rather than in the dictionaries on purpose. The address is the same
 * in Portuguese, English and Spanish, and a fact that happens to be spelled the same
 * three times is not translation — it is the same string with three chances to drift,
 * which is the argument `content/apps.ts` already makes about product names and
 * bundle identifiers.
 *
 * Sentences that need to mention it take an `{email}` placeholder and are filled from
 * here at render, so the three translations keep their own grammar around an address
 * that is not theirs to change.
 */

/** The address, bare. Never translated, never duplicated. */
export const CONTACT_EMAIL = 'm@m2on.org';

/**
 * A `mailto:` for it.
 *
 * Built here rather than written as `mailto:${CONTACT_EMAIL}` at the call site so
 * there is exactly one place where that prefix exists, and so the link and the text
 * cannot end up describing two different people.
 */
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;